import { render, staticRenderFns } from "./tasknotify.vue?vue&type=template&id=59af4511&scoped=true"
import script from "./tasknotify.vue?vue&type=script&lang=js"
export * from "./tasknotify.vue?vue&type=script&lang=js"
import style0 from "./tasknotify.vue?vue&type=style&index=0&id=59af4511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59af4511",
  null
  
)

export default component.exports